import React, { useState } from "react";
import { Modal, Button, Spin } from "antd";
import { DownloadOutlined } from "@ant-design/icons";

const CVPreviewModal = ({
  isOpen,
  onClose,
  htmlContent,
  onDownload,
  isDownloading,
}) => {
  return (
    <Modal
      title="CV Önizleme"
      open={isOpen}
      onCancel={onClose}
      width="80%"
      style={{ top: 20 }}
      footer={[
        <Button
          key="download"
          type="primary"
          icon={<DownloadOutlined />}
          onClick={onDownload}
          loading={isDownloading}>
          PDF İndir
        </Button>,
      ]}>
      <div style={{ position: "relative", minHeight: "80vh" }}>
        {htmlContent ? (
          <iframe
            srcDoc={htmlContent}
            title="CV Preview"
            style={{
              width: "100%",
              height: "75vh",
              border: "none",
            }}
            sandbox="allow-same-origin"
          />
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "75vh",
            }}>
            <Spin size="large" />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default CVPreviewModal;
